module.exports = __webpack_public_path__ + "static/media/email_icon.6f1a3524.svg";